
import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../honcierge-api"
import { AxiosError } from "axios"
import { DataTableHeader } from "vuetify/types"
import { AppAffiliate, AppAffiliateTemplate } from "types/appAffiliate"

@Component
export default class EditAppAffiliateTemplate extends Vue {
  @Prop()
  private dialog!: boolean

  public id = -1
  public name = ""
  public appAffiliateId: AppAffiliateTemplate["data"]["appAffiliate"]["id"] = -1
  public isHtmlOnly = false
  public adUrl = ""
  public adUrlIos = ""
  public adUrlAndroid = ""
  public htmlArea = ""
  public htmlAreaIos = ""
  public htmlAreaAndroid = ""
  public adText = ""
  public isEnabled = true
  public needExcuse = false
  public needExcusePr = false

  public appAffiliates: AppAffiliate["data"][] = []

  public articles: AppAffiliateTemplate["data"]["articles"] = []

  // rules for form
  private nameRules = [(name: string) => !!name || "名前は必須です"]
  private adTextRules = [
    (adText: string) => !!adText || "ボタンテキストは必須です",
  ]

  get headers(): DataTableHeader[] {
    return [
      { text: "編集", value: "", sortable: false },
      { text: "ID", value: "id" },
      { text: "タイトル", value: "title" },
      { text: "ステータス", value: "status" },
    ]
  }

  public updateAppAffiliateTemplate(): void {
    if (!this.validate()) {
      return
    }
    api
      .updateAppAffiliateTemplate({
        id: this.id,
        appAffiliateId: this.appAffiliateId,
        name: this.name,
        isHtmlOnly: this.isHtmlOnly,
        adUrl: this.adUrl,
        adUrlAndroid: this.adUrlAndroid,
        adUrlIos: this.adUrlIos,
        adText: this.adText,
        htmlArea: this.htmlArea,
        htmlAreaAndroid: this.htmlAreaAndroid,
        htmlAreaIos: this.htmlAreaIos,
        isEnabled: this.isEnabled,
        needExcuse: this.needExcuse,
        needExcusePr: this.needExcusePr,
      })
      .then((res) => {
        this.emitAppAffiliateTemplate(res.data)
        this.$toasted.success("アプリアフィリエイトテンプレートを更新しました")
      })
      .catch((e) => {
        this.$toasted.error(e.response.data.messages)
      })
  }

  public createAppAffiliateTemplate(): void {
    if (!this.validate()) {
      return
    }
    api
      .createAppAffiliateTemplate({
        appAffiliateId: this.appAffiliateId,
        name: this.name,
        isHtmlOnly: this.isHtmlOnly,
        adUrl: this.adUrl,
        adUrlAndroid: this.adUrlAndroid,
        adUrlIos: this.adUrlIos,
        adText: this.adText,
        htmlArea: this.htmlArea,
        htmlAreaAndroid: this.htmlAreaAndroid,
        htmlAreaIos: this.htmlAreaIos,
        isEnabled: this.isEnabled,
        needExcuse: this.needExcuse,
        needExcusePr: this.needExcusePr,
      })
      .then((res) => {
        this.emitAppAffiliateTemplate(res.data)
        this.$toasted.success(
          "アプリアフィリエイトテンプレートを新規作成しました"
        )
      })
      .catch((e: AxiosError) => {
        if (e.response) {
          this.$toasted.error(e.response.data.messages)
        }
      })
  }

  @Emit("emitAppAffiliateTemplate")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitAppAffiliateTemplate(appAffiliateTemplate: {
    appAffiliateTemplate: AppAffiliateTemplate["data"]
  }) {
    this.close()
  }

  @Emit("close")
  private close() {
    this.init()
    this.resetValidation()
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<
      typeof EditAppAffiliateTemplate
    >
    return form.validate()
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<
      typeof EditAppAffiliateTemplate
    >
    return form.resetValidation()
  }

  public init(): void {
    this.id = -1
    this.name = ""
    this.appAffiliateId = -1
    this.isHtmlOnly = false
    this.adUrl = ""
    this.adUrlIos = ""
    this.adUrlAndroid = ""
    this.htmlArea = ""
    this.htmlAreaIos = ""
    this.htmlAreaAndroid = ""
    this.adText = ""
    this.isEnabled = true
    this.needExcuse = false
    this.needExcusePr = false
    this.articles = []
  }
}
